import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const superwallProps = {
    // If we ever change this, we must change app/api-utils/trpc/routers/localization/constants.ts
    localizationMechanism: T.literalEnum("manual", "automatic")
};
/** @internal */ export const superwallLocalizationProviderMigrations = defineMigrations({});
export const SuperwallLocalizationProviderInfo = {
    migrations: superwallLocalizationProviderMigrations,
    props: superwallProps
};
